import { render, staticRenderFns } from "./PurchaseTips.vue?vue&type=template&id=16eb7239&scoped=true&"
var script = {}
import style0 from "./PurchaseTips.vue?vue&type=style&index=0&id=16eb7239&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16eb7239",
  null
  
)

export default component.exports